webpackJsonp([28],{

/***/ 1507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(1803);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af5b819_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1923);
function injectStyle (ssrContext) {
  __webpack_require__(1913)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7af5b819"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af5b819_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(1546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(1553);
function injectStyle (ssrContext) {
  __webpack_require__(1551)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64c87b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  emits: ['onClick'],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    buttonClass: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick() {
      this.$emit('onClick');
    }
  },
  computed: {
    buttonDef: function buttonDef() {
      return this.buttonClass === '' ? 'my-button' : '' + this.buttonClass;
    }
  }
});

/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1552);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("9f84328e", content, true, {});

/***/ }),

/***/ 1552:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".my-button[data-v-64c87b52]{background:transparent;outline:none;border:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Button.vue"],"names":[],"mappings":"AACA,4BACI,uBAAwB,AACxB,aAAc,AACd,WAAa,CAChB","file":"Button.vue","sourcesContent":["\n.my-button[data-v-64c87b52] {\n    background: transparent;\n    outline: none;\n    border: none;\n}\n.my-button[data-v-64c87b52]:hover {\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonDef,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t(_vm.title))+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1803:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Button_vue__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CheckBox_vue__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CookiesModal_vue__ = __webpack_require__(1919);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {},
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_0__components_Button_vue__["a" /* default */],
        CheckBox: __WEBPACK_IMPORTED_MODULE_1__components_CheckBox_vue__["a" /* default */],
        CookiesModal: __WEBPACK_IMPORTED_MODULE_2__components_CookiesModal_vue__["a" /* default */]
    },
    mounted: function mounted() {
        var token = localStorage.getItem('token');
        if (token) {
            this.$router.push('/systems');
        }
    },
    data: function data() {
        return {
            loginMode: true,
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            passwordConfirm: '',
            termsOfService: true,
            firstNameErrorMsg: '',
            lastNameErrorMsg: '',
            emailErrorMsg: '',
            passwordErrorMsg: '',
            passwordConfirmErrorMsg: '',
            termsOfServiceErrorMsg: '',
            serverErrors: []
        };
    },

    computed: {
        confirmTitle: function confirmTitle() {
            return this.loginMode ? "SignIn" : "SignOn";
        }
    },
    methods: {
        signIn: function signIn() {
            this.resetValues();
            this.loginMode = true;
        },
        signOn: function signOn() {
            this.resetValues();
            this.loginMode = false;
        },
        resetValues: function resetValues() {
            this.firstName = '';
            this.lastName = '';
            this.email = '';
            this.password = '';
            this.passwordConfirm = '';
            this.termsOfService = false;
            this.firstNameErrorMsg = '';
            this.lastNameErrorMsg = '';
            this.emailErrorMsg = '';
            this.passwordErrorMsg = '';
            this.passwordConfirmErrorMsg = '';
            this.termsOfServiceErrorMsg = '';
            this.serverErrors = [];
        },
        confirm: function confirm() {
            if (this.loginMode === true) {
                this.isEmailValid();
                this.isPasswordValid();
                this.isPasswordConfirmValid();
                if (this.emailErrorMsg.length === 0 && this.passwordErrorMsg.length === 0) {
                    this.login();
                }
            } else {
                this.isEmailValid();
                this.isPasswordValid();
                this.isPasswordConfirmValid();
                this.isFirstNameValid();
                this.isLastNameValid();
                if (this.emailErrorMsg.length === 0 && this.passwordErrorMsg.length === 0 && this.firstNameErrorMsg.length === 0 && this.lastNameErrorMsg.length === 0 && this.passwordConfirmErrorMsg.length === 0) {
                    this.register();
                }
            }
        },
        login: function login() {
            var _this = this;

            var user = {
                Password: this.password,
                Email: this.email
            };

            this.$store.dispatch('login', user).then(function () {
                return _this.$router.push('/systems');
            }).then(function () {
                _this.$router.push('/systems');
            }).catch(function (error) {
                _this.serverErrors = [_this.$t('LoginIncorrect')];
                //    console.log(error)
                if (error == 'Unauthorized access') {
                    _this.serverErrors = [_this.$t('UnauthorizedRole')];
                } else {
                    _this.serverErrors = [_this.$t('LoginIncorrect')];
                }
            });
        },
        register: function register() {
            var _this2 = this;

            var user = {
                FirstName: this.firstName,
                LastName: this.lastName,
                Password: this.password,
                Email: this.email
            };

            this.$store.dispatch('register', user).then(function () {
                return _this2.$router.push('/main');
            }).catch(function (error) {
                _this2.serverErrors = error.response.data.map(function (m) {
                    return m.description;
                });
            });
        },
        emailChange: function emailChange(value) {
            this.email = value.target.value;
            this.isEmailValid();
        },
        isEmailValid: function isEmailValid() {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            var isEmail = re.test(String(this.email).toLowerCase());

            if (this.email.length === 0) {
                this.emailErrorMsg = this.$t('EmailRequired');
            } else if (!isEmail) {
                this.emailErrorMsg = this.$t('EmailInvalid');
            } else {
                this.emailErrorMsg = '';
            }
        },
        passwordChange: function passwordChange(value) {
            this.password = value.target.value;
            this.isPasswordValid();
        },
        isPasswordValid: function isPasswordValid() {
            var mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");
            var isPassword = mediumRegex.test(String(this.password).toLowerCase());
            if (this.password.length === 0) {
                this.passwordErrorMsg = this.$t('PasswordRequired');
            } else if (!isPassword && !this.loginMode) {
                this.passwordErrorMsg = this.$t('PasswordRules');
            } else {
                this.passwordErrorMsg = '';
            }
        },
        passwordConfirmChange: function passwordConfirmChange(value) {
            this.passwordConfirm = value.target.value;
            this.isPasswordConfirmValid();
        },
        isPasswordConfirmValid: function isPasswordConfirmValid() {
            if (this.passwordConfirm.length === 0) {
                this.passwordConfirmErrorMsg = this.$t('ConfirmPasswordRequired');
            } else {
                this.passwordConfirmErrorMsg = '';
            }
        },
        firstNameChange: function firstNameChange(value) {
            this.firstName = value.target.value;
            this.isFirstNameValid();
        },
        isFirstNameValid: function isFirstNameValid() {
            if (this.firstName.length === 0) {
                this.firstNameErrorMsg = this.$t('FirstNameRequired');
            } else {
                this.firstNameErrorMsg = '';
            }
        },
        lastNameChange: function lastNameChange(value) {
            this.lastName = value.target.value;
            this.isLastNameValid();
        },
        isLastNameValid: function isLastNameValid() {
            if (this.lastName.length === 0) {
                this.lastNameErrorMsg = this.$t('LastNameRequired');
            } else {
                this.lastNameErrorMsg = '';
            }
        },
        termsOfServiceChange: function termsOfServiceChange() {
            this.termsOfService = !this.termsOfService;
            this.isTermsOfServiceValid();
        },
        isTermsOfServiceValid: function isTermsOfServiceValid() {
            if (this.termsOfService === false) {
                this.termsOfServiceErrorMsg = this.$t('Required');
            } else {
                this.termsOfServiceErrorMsg = '';
            }
        },
        openPolicy: function openPolicy() {
            this.$router.push({ name: 'policy' });
        }
    }
});

/***/ }),

/***/ 1804:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  emits: ['change'],
  props: ["checked", "index"],
  watch: {
    checked: function checked(newVal, oldVal) {
      this.isChecked = newVal;
    }
  },
  data: function data() {
    return {
      isChecked: this.checked
    };
  },

  methods: {
    selectionChanged: function selectionChanged(index) {
      this.$emit('change', index);
    }
  }
});

/***/ }),

/***/ 1805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    props: ['showDialog', 'maxWidth', 'title'],
    watch: {
        showDialog: function showDialog(newVal, oldVal) {}
    },
    methods: {
        accept: function accept() {
            this.$store.dispatch('update_cookies', true);
        },
        moreInfo: function moreInfo() {}
    },
    components: {},
    computed: {
        style: function style() {
            return 'max-width: ' + this.maxWidth;
        }
    },
    mounted: function mounted() {},
    data: function data() {
        return {};
    },
    created: function created() {}
});

/***/ }),

/***/ 1913:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1914);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("bd4e1342", content, true, {});

/***/ }),

/***/ 1914:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(1505);
exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".gradient[data-v-7af5b819]{background-image:-webkit-gradient(linear,left top,left bottom,from(#31929f),to(#356a86));background-image:linear-gradient(#31929f,#356a86)}.label[data-v-7af5b819]{font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:600!important;font-size:.8rem!important;color:#fff}p[data-v-7af5b819]{color:#fff}.underlined[data-v-7af5b819]{text-decoration:underline}.bold[data-v-7af5b819]{font-weight:700}.bg[data-v-7af5b819]{text-align:center;background-color:#fff;background-image:url(" + escape(__webpack_require__(1506)) + ");background-size:cover;background-repeat:no-repeat;background-position:0 0}.error[data-v-7af5b819]{text-align:left!important;color:#fd8282;font-size:11px;font-weight:700;font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important}input[data-v-7af5b819],input[data-v-7af5b819]:focus{background:transparent;border:none;border-bottom:1px solid #fff;padding-left:0;font-size:1rem;font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important;padding-left:10px;color:#add0d7}input[data-v-7af5b819]:-webkit-autofill,input[data-v-7af5b819]:-webkit-autofill:focus,input[data-v-7af5b819]:-webkit-autofill:hover,select[data-v-7af5b819]:-webkit-autofill,select[data-v-7af5b819]:-webkit-autofill:focus,select[data-v-7af5b819]:-webkit-autofill:hover,textarea[data-v-7af5b819]:-webkit-autofill,textarea[data-v-7af5b819]:-webkit-autofill:focus,textarea[data-v-7af5b819]:-webkit-autofill:hover{border:0 solid green;-webkit-text-fill-color:#add0d7;-webkit-box-shadow:0 0 0 0 transparent inset;-webkit-transition:background-color 5000s ease-in-out 0s;transition:background-color 5000s ease-in-out 0s;border-bottom:1px solid #fff}input[data-v-7af5b819]::-webkit-input-placeholder{color:#a6c2cd}input[data-v-7af5b819]::-moz-placeholder{color:#a6c2cd}input[data-v-7af5b819]::-ms-input-placeholder{color:#a6c2cd}input[data-v-7af5b819]::placeholder{color:#a6c2cd}.footer[data-v-7af5b819]{position:absolute;bottom:0}.lightColor[data-v-7af5b819]{color:#8eabb9;background:#8eabb9}.themeColor[data-v-7af5b819]{color:#337b91;background:#337b91}.rounded[data-v-7af5b819]{border-radius:.75rem!important}.no-radius[data-v-7af5b819]{border-radius:0}.confirm-button[data-v-7af5b819]{color:#fff;background:#8fd1aa;border-radius:30px;border:none;font-size:15px}.login-button[data-v-7af5b819]{color:#fff;background:transparent;border:none}.noselect[data-v-7af5b819]{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Login.vue"],"names":[],"mappings":"AACA,2BACI,yFAA8F,AAC9F,iDAAoD,CACvD,AACD,wBACI,2CAAgD,AAChD,4BAA8B,AAC9B,0BAA4B,AAC5B,0BAA6B,AAC7B,UAAa,CAChB,AACD,mBACI,UAAa,CAChB,AACD,6BACI,yBAA2B,CAC9B,AACD,uBACE,eAAkB,CACnB,AACD,qBACE,kBAAmB,AACnB,sBAAwB,AACxB,+CAAgD,AAChD,sBAAuB,AACvB,4BAA6B,AAC7B,uBAA8B,CAC/B,AACD,wBACI,0BAA4B,AAC5B,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,2CAAgD,AAChD,4BAA8B,AAC9B,yBAA4B,CAC/B,AAaD,oDAXI,uBAAwB,AACxB,YAAa,AACb,6BAA+B,AAC/B,eAAgB,AAChB,eAAgB,AAChB,2CAAgD,AAChD,4BAA8B,AAC9B,0BAA4B,AAC5B,kBAAmB,AACnB,aAAe,CAalB,AACD,wZASI,qBAAwB,AACxB,gCAAiC,AACjC,6CAAkD,AAClD,yDAA0D,AAC1D,iDAAkD,AAClD,4BAA+B,CAClC,AACD,kDACI,aAA0B,CAC7B,AACD,yCACI,aAA0B,CAC7B,AACD,8CACI,aAA0B,CAC7B,AACD,oCACI,aAA0B,CAC7B,AACD,yBACI,kBAAmB,AACnB,QAAU,CACb,AACD,6BACI,cAA0B,AAC1B,kBAA+B,CAClC,AACD,6BACI,cAAyB,AACzB,kBAA8B,CACjC,AACD,0BACI,8BAAgC,CACnC,AACD,4BACI,eAAiB,CACpB,AACD,iCACI,WAAa,AACb,mBAA+B,AAC/B,mBAAoB,AACpB,YAAa,AACb,cAAgB,CACnB,AACD,+BACI,WAAa,AACb,uBAAwB,AACxB,WAAa,CAChB,AACD,2BACI,2BAA4B,AAC5B,yBAA0B,AAC1B,sBAAuB,AACvB,qBAAsB,AACtB,gBAAkB,CACrB","file":"Login.vue","sourcesContent":["\n.gradient[data-v-7af5b819] {\n    background-image: -webkit-gradient(linear, left top, left bottom, from(#31929f), to(#356a86));\n    background-image: linear-gradient(#31929f, #356a86);\n}\n.label[data-v-7af5b819] {\n    font-family: 'Open Sans', sans-serif !important;\n    font-style: normal !important;\n    font-weight: 600 !important;\n    font-size: 0.8rem !important;\n    color: white;\n}\np[data-v-7af5b819] {\n    color: white;\n}\n.underlined[data-v-7af5b819] {\n    text-decoration: underline;\n}\n.bold[data-v-7af5b819] {\n  font-weight: bold;\n}\n.bg[data-v-7af5b819] {\n  text-align: center;\n  background-color: white;\n  background-image: url('~@/assets/img/cows.jpg');\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: left top;\n}\n.error[data-v-7af5b819] {\n    text-align: left !important;\n    color: #FD8282;\n    font-size: 11px;\n    font-weight: bold;\n    font-family: 'Open Sans', sans-serif !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n}\ninput[data-v-7af5b819] {\n    background: transparent;\n    border: none;\n    border-bottom: 1px solid white;\n    padding-left: 0;\n    font-size: 1rem;\n    font-family: 'Open Sans', sans-serif !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n    padding-left: 10px;\n    color: #ADD0D7;\n}\ninput[data-v-7af5b819]:focus {\n    background: transparent;\n    border: none;\n    border-bottom: 1px solid white;\n    padding-left: 0;\n    font-size: 1rem;\n    font-family: 'Open Sans', sans-serif !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n    padding-left: 10px;\n    color: #ADD0D7;\n}\ninput[data-v-7af5b819]:-webkit-autofill,\ninput[data-v-7af5b819]:-webkit-autofill:hover,\ninput[data-v-7af5b819]:-webkit-autofill:focus,\ntextarea[data-v-7af5b819]:-webkit-autofill,\ntextarea[data-v-7af5b819]:-webkit-autofill:hover,\ntextarea[data-v-7af5b819]:-webkit-autofill:focus,\nselect[data-v-7af5b819]:-webkit-autofill,\nselect[data-v-7af5b819]:-webkit-autofill:hover,\nselect[data-v-7af5b819]:-webkit-autofill:focus {\n    border: 0px solid green;\n    -webkit-text-fill-color: #ADD0D7;\n    -webkit-box-shadow: 0 0 0px 0px transparent inset;\n    -webkit-transition: background-color 5000s ease-in-out 0s;\n    transition: background-color 5000s ease-in-out 0s;\n    border-bottom: 1px solid white;\n}\ninput[data-v-7af5b819]::-webkit-input-placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: rgb(166, 194, 205);\n}\ninput[data-v-7af5b819]::-moz-placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: rgb(166, 194, 205);\n}\ninput[data-v-7af5b819]::-ms-input-placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: rgb(166, 194, 205);\n}\ninput[data-v-7af5b819]::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: rgb(166, 194, 205);\n}\n.footer[data-v-7af5b819] {\n    position: absolute;\n    bottom: 0;\n}\n.lightColor[data-v-7af5b819] {\n    color: rgb(142, 171, 185);\n    background: rgb(142, 171, 185);\n}\n.themeColor[data-v-7af5b819] {\n    color: rgb(51, 123, 145);\n    background: rgb(51, 123, 145);\n}\n.rounded[data-v-7af5b819] {\n    border-radius:.75rem !important;\n}\n.no-radius[data-v-7af5b819] {\n    border-radius: 0;\n}\n.confirm-button[data-v-7af5b819] {\n    color: white;\n    background: rgb(143, 209, 170);\n    border-radius: 30px;\n    border: none;\n    font-size: 15px;\n}\n.login-button[data-v-7af5b819] {\n    color: white;\n    background: transparent;\n    border: none;\n}\n.noselect[data-v-7af5b819] {\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1915:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckBox_vue__ = __webpack_require__(1804);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e64792c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckBox_vue__ = __webpack_require__(1918);
function injectStyle (ssrContext) {
  __webpack_require__(1916)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e64792c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e64792c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1916:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1917);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("29e5a602", content, true, {});

/***/ }),

/***/ 1917:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".chb-container[data-v-4e64792c]{position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.chb-container input[data-v-4e64792c]{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.checkmark[data-v-4e64792c]{position:absolute;top:0;left:0;height:20px;width:20px;border-radius:3px;background-color:#8fd1ab}.chb-container:hover input~.checkmark[data-v-4e64792c],.chb-container input:checked~.checkmark[data-v-4e64792c]{background-color:#8fd1ab}.checkmark[data-v-4e64792c]:after{content:\"\";position:absolute;display:none}.chb-container input:checked~.checkmark[data-v-4e64792c]:after{display:block}.chb-container .checkmark[data-v-4e64792c]:after{left:6px;top:3px;width:6px;height:11px;border:solid #000;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/CheckBox.vue"],"names":[],"mappings":"AACA,gCACE,kBAAmB,AACnB,eAAgB,AAChB,yBAA0B,AAC1B,sBAAuB,AACvB,qBAAsB,AACtB,gBAAkB,CACnB,AAGD,sCACE,kBAAmB,AACnB,UAAW,AACX,eAAgB,AAChB,SAAU,AACV,OAAS,CACV,AAGD,4BACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,YAAa,AACb,WAAY,AACZ,kBAAmB,AACnB,wBAAqC,CACtC,AAQD,gHACE,wBAAqC,CACtC,AAGD,kCACE,WAAY,AACZ,kBAAmB,AACnB,YAAc,CACf,AAGD,+DACE,aAAe,CAChB,AAGD,iDACE,SAAU,AACV,QAAS,AACT,UAAW,AACX,YAAa,AACb,kBAAoB,AACpB,yBAA0B,AAC1B,gCAAiC,AACjC,uBAAyB,CAC1B","file":"CheckBox.vue","sourcesContent":["\n.chb-container[data-v-4e64792c] {\n  position: relative;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* Hide the browser's default checkbox */\n.chb-container input[data-v-4e64792c] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n/* Create a custom checkbox */\n.checkmark[data-v-4e64792c] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 20px;\n  width: 20px;\n  border-radius: 3px;   \n  background-color: rgb(143, 209, 171);\n}\n\n/* On mouse-over, add a grey background color */\n.chb-container:hover input ~ .checkmark[data-v-4e64792c] {\n  background-color: rgb(143, 209, 171);\n}\n\n/* When the checkbox is checked, add a blue background */\n.chb-container input:checked ~ .checkmark[data-v-4e64792c] {\n  background-color: rgb(143, 209, 171);\n}\n\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark[data-v-4e64792c]:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n/* Show the checkmark when checked */\n.chb-container input:checked ~ .checkmark[data-v-4e64792c]:after {\n  display: block;\n}\n\n/* Style the checkmark/indicator */\n.chb-container .checkmark[data-v-4e64792c]:after {\n  left: 6px;\n  top: 3px;\n  width: 6px;\n  height: 11px;\n  border: solid black;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1918:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grow",staticStyle:{"display":"flex"}},[_c('label',{staticClass:"chb-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isChecked),expression:"isChecked"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isChecked)?_vm._i(_vm.isChecked,null)>-1:(_vm.isChecked)},on:{"change":[function($event){var $$a=_vm.isChecked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isChecked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isChecked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isChecked=$$c}},function($event){return _vm.selectionChanged(_vm.index)}]}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1919:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookiesModal_vue__ = __webpack_require__(1805);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca72ad1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookiesModal_vue__ = __webpack_require__(1922);
function injectStyle (ssrContext) {
  __webpack_require__(1920)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca72ad1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookiesModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca72ad1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookiesModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1920:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1921);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("8e5c31bc", content, true, {});

/***/ }),

/***/ 1921:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-ca72ad1a]{position:fixed;z-index:10;left:0;top:0;width:100%;height:100%;overflow:auto;display:block;background-color:rgba(0,0,0,.4)}.flex-container[data-v-ca72ad1a]{height:100%;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.modal-content[data-v-ca72ad1a]{background-color:#fefefe;border:1px solid #888;width:auto;z-index:1000;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}.modal-header[data-v-ca72ad1a]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:16px;font-style:normal;font-weight:600;color:#fff}.close[data-v-ca72ad1a]{color:#fff;float:right;font-size:28px;font-weight:700}.close[data-v-ca72ad1a]:focus,.close[data-v-ca72ad1a]:hover{color:#000;text-decoration:none;cursor:pointer}.widthClass[data-v-ca72ad1a]{max-width:30%}.modal-slot[data-v-ca72ad1a]{max-width:400px}#mdiv[data-v-ca72ad1a]{width:25px;height:25px;cursor:pointer}.mdiv[data-v-ca72ad1a]{height:25px;width:2px;margin-left:12px;background-color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg);Z-index:1}.md[data-v-ca72ad1a]{height:25px;width:2px;background-color:#fff;-webkit-transform:rotate(90deg);transform:rotate(90deg);Z-index:2}.button-agree[data-v-ca72ad1a]{color:#fff;background:#617590;padding:10px 20px}.button-agree[data-v-ca72ad1a],.button-settings[data-v-ca72ad1a]{border:1px solid #617590;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:20px;font-size:16px}.button-settings[data-v-ca72ad1a]{padding:5px 10px;color:#617590}.header-cookies[data-v-ca72ad1a]{margin-top:60px;font-style:normal;font-weight:700;font-size:24px;line-height:28px;margin-bottom:30px;color:#272727}.cookies-context[data-v-ca72ad1a]{font-style:normal;font-weight:400;font-size:14px;line-height:118.69%;color:#272727;margin-bottom:20px;letter-spacing:.05em}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/CookiesModal.vue"],"names":[],"mappings":"AACA,wBACI,eAAgB,AAChB,WAAY,AACZ,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,cAAe,AACf,cAAe,AACf,+BAAkC,CACrC,AACD,iCACI,YAAa,AACb,UAAW,AACX,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,gCACI,yBAA0B,AAC1B,sBAAuB,AACvB,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,WAAa,AACb,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB,AACD,4DAEI,WAAa,AACb,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,aAAe,CAClB,AACD,6BACI,eAAiB,CAGpB,AACD,uBACE,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,qBACE,YAAa,AACb,UAAW,AACX,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,+BACI,WAAa,AACb,mBAAoB,AAMpB,iBAAmB,CACtB,AACD,iEAPI,yBAA0B,AAC1B,8BAA+B,AACvB,sBAAuB,AAC/B,mBAAoB,AACpB,cAAgB,CAWnB,AARD,kCACI,iBAAkB,AAClB,aAAe,CAMlB,AACD,iCACI,gBAAiB,AACjB,kBAAmB,AACnB,gBAAkB,AAClB,eAAgB,AAChB,iBAAkB,AAClB,mBAAoB,AAEpB,aAAe,CAClB,AACD,kCACI,kBAAmB,AACnB,gBAAoB,AACpB,eAAgB,AAChB,oBAAqB,AACrB,cAAe,AACf,mBAAoB,AACpB,oBAAuB,CAC1B","file":"CookiesModal.vue","sourcesContent":["\n.modal[data-v-ca72ad1a] {\n    position: fixed;\n    z-index: 10;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: block;\n    background-color: rgba(0,0,0,0.4);\n}\n.flex-container[data-v-ca72ad1a] {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.modal-content[data-v-ca72ad1a] {\n    background-color: #fefefe;\n    border: 1px solid #888;\n    width: auto;\n    z-index: 1000;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n.modal-header[data-v-ca72ad1a] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.close[data-v-ca72ad1a] {\n    color: white;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n.close[data-v-ca72ad1a]:hover,\n.close[data-v-ca72ad1a]:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n.widthClass[data-v-ca72ad1a] {\n    max-width: 30%;\n}\n.modal-slot[data-v-ca72ad1a] {\n    max-width: 400px;\n    /* margin-right: 10px;\n    margin-left: 10px; */\n}\n#mdiv[data-v-ca72ad1a] {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n.mdiv[data-v-ca72ad1a] {\n  height: 25px;\n  width: 2px;\n  margin-left: 12px;\n  background-color: white;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  Z-index: 1;\n}\n.md[data-v-ca72ad1a] {\n  height: 25px;\n  width: 2px;\n  background-color: white;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  Z-index: 2;\n}\n.button-agree[data-v-ca72ad1a] {\n    color: white;\n    background: #617590;\n    border: 1px solid #617590;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border-radius: 20px;\n    font-size: 16px;\n    padding: 10px 20px;\n}\n.button-settings[data-v-ca72ad1a] {\n    padding: 5px 10px;\n    color: #617590;\n    border: 1px solid #617590;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border-radius: 20px;\n    font-size: 16px;\n}\n.header-cookies[data-v-ca72ad1a] {\n    margin-top: 60px;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 24px;\n    line-height: 28px;\n    margin-bottom: 30px;\n\n    color: #272727;\n}\n.cookies-context[data-v-ca72ad1a] {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 118.69%;\n    color: #272727;\n    margin-bottom: 20px;\n    letter-spacing: 0.05em;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1922:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal flex-container",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.$emit('close')}}},[_c('div',{staticClass:"modal-content vertical",style:(_vm.style)},[_c('div',{staticClass:"modal-slot"},[_c('div',{staticStyle:{"margin":"0 40px","border-bottom":"0.5px solid #AEAEAE"}},[_c('div',{staticClass:"header-cookies"},[_vm._v("\n                    "+_vm._s(_vm.$t('CookieSettings'))+"\n                ")]),_vm._v(" "),_c('div',[_c('p',{staticClass:"cookies-context"},[_vm._v(_vm._s(_vm.$t('CookiesText')))])]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"space-around","margin-bottom":"25px"}},[_c('button',{staticClass:"button-settings",on:{"click":_vm.moreInfo}},[_vm._v(_vm._s(_vm.$t('MoreInformation')))]),_vm._v(" "),_c('button',{staticClass:"button-agree",on:{"click":_vm.accept}},[_vm._v(_vm._s(_vm.$t('Apply')))])])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"20px 40px 0 40px"}},[_c('p',{staticClass:"cookies-context",staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$t('CookiesChangeSettings'))+" "),_c('a',{attrs:{"href":"https://support.google.com/chrome/answer/95647","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('CookiesThisPage')))]),_vm._v(". "),_c('b',[_vm._v(_vm._s(_vm.$t('CookiesPolicyDetails')))])])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-h d-flex flex-column"},[_c('cookies-modal',{attrs:{"showDialog":!_vm.$store.getters.cookies}}),_vm._v(" "),_c('div',{staticClass:"bg",staticStyle:{"flex-grow":"1","display":"flex","flex-direction":"column"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row no-gutters align-items-center justify-content-around",staticStyle:{"flex-grow":"1"}},[_c('div',{staticClass:"col-sm-10 col-md-12 col-lg-4 flex-column mr-4"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-auto align-items-left"},[_c('p',{staticClass:"text-center extra-bold display-4 noselect"},[_vm._v(_vm._s(_vm.$t('LoginHeadline')))]),_vm._v(" "),_c('p',{staticClass:"text-center regular mt-4 noselect",staticStyle:{"font-size":"1.3rem"}},[_vm._v(_vm._s(_vm.$t('LoginSubline')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-4 gradient rounded p-5 m-4",staticStyle:{"max-width":"400px"}},[_c('div',{staticClass:"d-flex flex-row justify-content-start align-items-center mb-4 w-100"},[_c('Button',{staticClass:"p-0",staticStyle:{"font-size":"24px"},attrs:{"buttonClass":"login-button semi-bold","title":"SignIn"},on:{"onClick":_vm.signIn}})],1),_vm._v(" "),_c('div',[_c('p',{staticClass:"label text-left mt-4 mb-1"},[_vm._v(_vm._s(_vm.$t('E_MAIL')))])]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control no-radius p-0",attrs:{"type":"email","name":"email","id":"email","placeholder":_vm.$t('EnterEmail'),"maxlength":"50"},domProps:{"value":(_vm.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.email=$event.target.value},_vm.emailChange],"blur":_vm.emailChange}}),_vm._v(" "),(this.emailErrorMsg.length != 0)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(this.emailErrorMsg))]):_vm._e()]),_vm._v(" "),_c('div',[_c('p',{staticClass:"label text-left mt-4 mb-1"},[_vm._v(_vm._s(_vm.$t('PASSWORD')))])]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control no-radius p-0",attrs:{"type":"password","name":"password","id":"password","placeholder":_vm.$t('EnterPassword'),"maxlength":"100","aria-describedby":"password-help-block"},domProps:{"value":(_vm.password)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login.apply(null, arguments)},"input":[function($event){if($event.target.composing){ return; }_vm.password=$event.target.value},_vm.passwordChange],"blur":_vm.passwordChange}}),_vm._v(" "),(this.passwordErrorMsg.length != 0)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(this.passwordErrorMsg))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column my-1 pt-3"},[_c('div',{staticClass:"d-flex flex-row mb-1"},[_c('Button',{staticClass:"px-3 py-3 mt-3",attrs:{"buttonClass":"semi-bold confirm-button flex-grow-1","title":_vm.confirmTitle},on:{"onClick":_vm.confirm}}),_vm._v(" "),(!_vm.loginMode)?_c('Button',{staticClass:"align-self-center underlined",staticStyle:{"font-size":"12px"},attrs:{"buttonClass":"login-button regular","title":"AlreadyMember"},on:{"onClick":function($event){_vm.loginMode = true}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row mb-1",staticStyle:{"justify-content":"center"}},_vm._l((_vm.serverErrors),function(item){return _c('span',{key:item,staticClass:"error"},[_vm._v(_vm._s(item))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row justify-content-between"},[_c('div',{staticClass:"ml-md-5"},[_c('p',{staticClass:"text-left regular",staticStyle:{"font-size":"12px"}},[_vm._v("Copyright "+_vm._s((new Date).getYear() + 1900)+" @ BioControl")])]),_vm._v(" "),_c('div',{staticClass:"mr-md-5"},[_c('Button',{staticClass:"regular login-button mr-3",staticStyle:{"font-size":"12px"},attrs:{"title":"GdprPrivacyPolicy"},on:{"onClick":_vm.openPolicy}}),_vm._v(" "),_c('Button',{staticClass:"regular login-button",staticStyle:{"font-size":"12px"},attrs:{"title":"CookiePolicy"}})],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-1 offset-lg-1 flex-column"},[_c('div',{staticClass:"mx-auto noselect"},[_c('img',{attrs:{"src":__webpack_require__(1924)}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1924:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// static/js/28.982b1d7005805146fc3c.js